import Accordions from "./accordions";
import Cart from "./cart";
import FilteredPostsList from "./filtered-posts-list";
//import GoogleMap from "./google-map";
import Lottie from "./lottie";
import Newsletter from "./newsletter";
import PbRowMedias from "./pb-row-medias";
import ProductForm from "./product-form";
import ProductPreview from "./product-preview";
import ProductRecommendations from "./product-recommendations";
import ProductSingle from "./product-single";
import ProductWishlist from "./product-wishlist";
// import PbRowTabs from "./pb-row-tabs";
// import PbRowTestimonials from "./pb-row-testimonials";
import PbRowSplashPage from "./pb-row-splash-page";
//import PrefersColorSchemeBtn from "./prefers-color-scheme-btn";
import Sharing from "./sharing";
import SvgPathLength from "./svg-path-length";
import TextTicker from './text-ticker';
import Video from "./video";

export default {
  Accordions,
  Cart,
  FilteredPostsList,
  //GoogleMap,
  Lottie,
  Newsletter,
  PbRowMedias,
  ProductForm,
  ProductPreview,
  ProductRecommendations,
  ProductSingle,
  ProductWishlist,
  // PbRowTabs,
  // PbRowTestimonials,
  PbRowSplashPage,
  //PrefersColorSchemeBtn,
  Sharing,
  SvgPathLength,
  TextTicker,
  Video,
};
